export const FinancingEmptyDecorator = ({ children }) => children;
